(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-product-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-product-guide')) {
    customElements.define('ck-product-guide',class extends HTMLElement {
      connectedCallback() {
        if(this.dataset.ready)return;
        this.panels=Array.from(this.querySelectorAll('.ck-guide__panel'));
        this.panels.forEach(panel=>{panel.id=this.id+'-'+panel.dataset.key;});
        const chart=JSON.parse(this.querySelector('[data-size-chart]').textContent);const chartHost=this.querySelector('[data-structured-chart]');if(chart.sizes?.length&&chart.rows?.length){const wrap=document.createElement('div');wrap.className='ck-guide__scroll';wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label',this.panels[1].querySelector('summary').textContent);const table=document.createElement('table'),head=document.createElement('thead'),row=document.createElement('tr');const title=document.createElement('th');title.scope='col';title.textContent=this.panels[1].querySelector('summary').textContent;row.append(title);chart.sizes.forEach(size=>{const th=document.createElement('th');th.scope='col';th.textContent=size;row.append(th);});head.append(row);table.append(head);const body=document.createElement('tbody');chart.rows.forEach(r=>{const row=document.createElement('tr'),label=document.createElement('th');label.scope='row';label.textContent=String(r.label).replace(/(?:1\s*\/\s*2|½)\s*chest/ig,'Half chest').replace(/chest\s+to\s+fit/ig,'Chest to fit');row.append(label);chart.sizes.forEach((_,i)=>{const cell=document.createElement('td');cell.textContent=r.values?.[i]||'—';row.append(cell);});body.append(row);});table.append(body);wrap.append(table);chartHost.append(wrap);}
        const target=this.querySelector('[data-size-tables]');
        this.querySelectorAll('[data-description] table').forEach(table=>{
          const title=table.querySelector('tr')?.cells[0]?.textContent.trim();
          if(title){const heading=document.createElement('h3');heading.textContent=title;target.append(heading);}
          const wrap=document.createElement('div');wrap.className='ck-guide__scroll';wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label',this.panels[1].querySelector('summary').textContent);wrap.append(table);target.append(wrap);
        });
        const labels=(chart.rows||[]).map(r=>String(r.label));
        const body=labels.some(label=>/chest\s+to\s+fit/i.test(label));
        const half=labels.some(label=>/(?:1\s*\/\s*2|½|half)\s*chest/i.test(label));
        this.querySelector('[data-body-note]').hidden=!body;
        this.querySelector('[data-half-note]').hidden=!half;
        this.querySelector('[data-units-note]').hidden=!labels.length;
        this.querySelectorAll('[data-description] h2').forEach(h=>{if(h.textContent.trim()==='Garment specifications and size guides')h.remove();});
        this.dataset.ready='true';
      }
      select(index){const panel=this.panels[index];if(panel){panel.open=true;panel.querySelector('summary').focus();}}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-quote-form"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ck-quote-form')){
class CKQuoteForm extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.form=this.querySelector('form');if(!this.form)return;
  this.storageKey='ck-quote-draft-v3';this.artLabels=JSON.parse(this.querySelector('[data-quote-art-labels]').textContent);
  if(this.querySelector('[data-success]')){try{sessionStorage.removeItem(this.storageKey);}catch{}return;}
  this.items=this.querySelector('[data-items]');this.prototype=this.items.querySelector('[data-item]').cloneNode(true);this.addButton=this.querySelector('[data-add]');this.addButton.hidden=false;this.querySelector('[data-review]').hidden=false;
  this.addButton.addEventListener('click',()=>this.add());
  this.form.addEventListener('input',()=>this.refresh());this.form.addEventListener('change',()=>this.refresh());
  this.items.addEventListener('click',event=>{const row=event.target.closest('[data-item]');if(!row)return;if(event.target.closest('[data-remove]')){const next=row.nextElementSibling||row.previousElementSibling;row.querySelectorAll('[data-artwork]').forEach(field=>field.uploadController?.abort());row.remove();this.refresh();(next?.querySelector('select')||this.addButton).focus({preventScroll:true});}else if(event.target.closest('[data-copy]'))this.add(row);});
  this.form.addEventListener('submit',event=>{this.refresh();if(!this.form.reportValidity()){event.preventDefault();return;}try{const draft={time:Date.now(),data:[...new FormData(this.form).entries()]};sessionStorage.setItem(this.storageKey,JSON.stringify(draft));}catch{}});
  this.form.addEventListener('invalid',event=>{const row=event.target.closest('[data-item]');if(row&&event.target.matches('[data-placement]'))row.querySelector('[data-placement-error]').hidden=false;},true);
  this.restore();this.refresh();
 }
 add(source){
  if(this.items.children.length>=30)return;
  const row=this.prototype.cloneNode(true);
  if(source){row.querySelectorAll('[data-key]').forEach(input=>{input.value=source.querySelector('[data-key="'+input.dataset.key+'"]').value;});row.querySelectorAll('[data-placement]').forEach(input=>{input.checked=source.querySelector('[data-placement="'+input.dataset.placement+'"]').checked;});row.querySelector('[data-key=size]').value='';row.querySelector('[data-key=quantity]').value='';}
  this.items.append(row);this.refresh();row.querySelector(source?'[data-key=size]':'select').focus({preventScroll:true});row.scrollIntoView({block:'nearest',behavior:'auto'});
 }
 restore(){
  if(!this.querySelector('[data-server-error]'))return;
  try{const draft=JSON.parse(sessionStorage.getItem(this.storageKey)||'null');if(!draft||Date.now()-draft.time>3600000||!Array.isArray(draft.data))return;const count=Math.min(30,Math.max(1,...draft.data.map(([key])=>Number(key.match(/^contact\[Item (\d+) -/)?.[1])||1)));while(this.items.children.length<count)this.items.append(this.prototype.cloneNode(true));this.refresh();for(let pass=0;pass<2;pass++){this.refresh();for(const [name,value] of draft.data){const input=[...this.form.elements].find(el=>el.name===name);if(!input||input.type==='file'||input.type==='hidden'&&!input.hasAttribute('data-art-url')||input.dataset.summary!==undefined)continue;if(input.type==='checkbox')input.checked=true;else input.value=value;}}}catch{}
 }
 artwork(){
  const host=this.querySelector('[data-placement-artwork]'),checks=new Map(),used=new Map();
  [...this.items.children].forEach((row,index)=>{for(const check of row.querySelectorAll('[data-placement]')){
   const key=check.dataset.placement;if(!checks.has(key))checks.set(key,check);
   if(check.checked&&!check.disabled){if(!used.has(key))used.set(key,[]);used.get(key).push(index+1);}
  }});
  this.querySelector('[data-shared-artwork]').hidden=!used.size;
  for(const [key,check] of checks){
   const active=used.has(key);let field=host.querySelector('[data-artwork="'+key+'"]');
   if(!field&&active){
    field=document.createElement('fieldset');field.className='ckq-artwork';field.dataset.artwork=key;
    const legend=document.createElement('legend');legend.textContent=check.value;field.append(legend);
    const help=document.createElement('p');help.dataset.artApplies='';field.append(help);
    const fileLabel=document.createElement('label');fileLabel.className='ckq-field';fileLabel.append(document.createTextNode(this.artLabels.upload));
    const file=document.createElement('input');file.type='file';file.accept='.png,.jpg,.jpeg,.svg,.pdf';file.dataset.artFile='';fileLabel.append(file);field.append(fileLabel);
    const status=document.createElement('p');status.dataset.artStatus='';status.setAttribute('role','status');field.append(status);
    const link=document.createElement('a');link.dataset.artLink='';link.target='_blank';link.rel='noopener';link.hidden=true;link.textContent=this.artLabels.view;field.append(link);
    const remove=document.createElement('button');remove.type='button';remove.dataset.artRemove='';remove.hidden=true;remove.textContent=this.artLabels.remove;field.append(remove);
    const url=document.createElement('input');url.type='hidden';url.dataset.artUrl='';field.append(url);
    const textLabel=document.createElement('label');textLabel.className='ckq-field';textLabel.append(document.createTextNode(this.artLabels.text));const text=document.createElement('textarea');text.rows=2;text.maxLength=1000;text.dataset.artText='';textLabel.append(text);field.append(textLabel);
    file.addEventListener('change',()=>this.uploadArtwork(field,file.files[0]));
    remove.addEventListener('click',()=>{field.uploadToken=(field.uploadToken||0)+1;field.uploadController?.abort();field.uploading=false;url.value='';file.value='';status.textContent='';this.refresh();});
    host.append(field);
   }
   if(!field)continue;field.hidden=!active;field.disabled=!active;
   const url=field.querySelector('[data-art-url]'),text=field.querySelector('[data-art-text]'),file=field.querySelector('[data-art-file]'),link=field.querySelector('[data-art-link]');
   field.querySelector('[data-art-applies]').textContent=this.artLabels.applies+' '+(used.get(key)||[]).join(', ');
   const prefix='contact[Artwork - '+check.value;
   url.name=prefix+' - Logo file]';text.name=prefix+' - Logo text]';
   file.disabled=!active||!!field.uploading;
   text.setCustomValidity(active?(field.uploading?this.artLabels.wait:!url.value&&!text.value.trim()?this.artLabels.required:''):'');
   link.hidden=!url.value;link.href=url.value||'#';field.querySelector('[data-art-remove]').hidden=!url.value;
  }
 }
 async uploadArtwork(field,file){
  if(!file)return;const status=field.querySelector('[data-art-status]'),input=field.querySelector('[data-art-file]');
  if(file.size===0||file.size>10*1024*1024||!/\.(png|jpe?g|svg|pdf)$/i.test(file.name)){status.textContent=this.artLabels.limit;input.value='';return;}
  const token=field.uploadToken=(field.uploadToken||0)+1;field.uploadController?.abort();const controller=field.uploadController=new AbortController();const timer=setTimeout(()=>controller.abort(),45000);field.uploading=true;status.textContent=this.artLabels.uploading;this.refresh();
  try{
   const data=new FormData();data.append('filetoupload',file);
   const response=await fetch('https://api-option.optis.me/upload-image/uploadFile?shopId=21768&domain=b0i1bw-f1.myshopify.com',{method:'POST',body:data,signal:controller.signal});const result=await response.json();
   if(!response.ok||!result.success||!result.cdn_url)throw Error();const url=new URL(result.cdn_url);if(url.protocol!=='https:')throw Error();
   if(token!==field.uploadToken)return;field.querySelector('[data-art-url]').value=url.href;status.textContent=this.artLabels.uploaded+' '+file.name;
  }catch(e){if(token===field.uploadToken)status.textContent=this.artLabels.error;}
  finally{clearTimeout(timer);if(token===field.uploadToken){field.uploading=false;input.value='';this.refresh();}}
 }

 refresh(){
  const lines=[],keyNames={type:'Type',brand:'Brand or code',description:'Description',colour:'Colour',size:'Size',quantity:'Quantity',logo_notes:'Logo details'};let total=0;
  [...this.items.children].forEach((row,i)=>{
   row.querySelector('[data-number]').textContent=i+1;
   row.querySelector('[data-copy]').hidden=false;row.querySelector('[data-copy]').disabled=this.items.children.length>=30;row.querySelector('[data-remove]').hidden=this.items.children.length===1;
   const type=row.querySelector('[data-key=type]').value;
   const other=row.querySelector('[data-key=description]');other.disabled=type!=='other_type';other.required=type==='other_type';other.closest('[data-other-item]').hidden=other.disabled;
   const placements=[...row.querySelectorAll('[data-placement]')];
   placements.forEach(check=>{let allowed=true;if(type==='headwear')allowed=['front','back','other'].includes(check.dataset.placement);else if(type==='bodywarmer')allowed=!['left_sleeve','right_sleeve','front'].includes(check.dataset.placement);else if(type==='trousers')allowed=check.dataset.placement==='other';else allowed=check.dataset.placement!=='front';check.disabled=!allowed;if(check.disabled)check.checked=false;check.closest('label').hidden=!allowed;check.setCustomValidity('');check.name='contact[Item '+(i+1)+' - '+check.value+']';});
   const chosen=placements.filter(check=>check.checked&&!check.disabled),first=placements.find(check=>!check.disabled);
   if(first&&!chosen.length)first.setCustomValidity(this.dataset.placementError);
   if(chosen.length)row.querySelector('[data-placement-error]').hidden=true;
   const logo=row.querySelector('[data-key=logo_notes]');logo.setCustomValidity(chosen.some(c=>c.dataset.placement==='other')&&!logo.value.trim()?this.dataset.otherError:'');
   lines.push('ITEM '+(i+1));row.querySelectorAll('[data-key]').forEach(input=>{input.name='contact[Item '+(i+1)+' - '+keyNames[input.dataset.key]+']';if(!input.disabled&&input.value){const value=input.tagName==='SELECT'?input.selectedOptions[0].textContent:input.value;lines.push(keyNames[input.dataset.key]+': '+value);}});
   lines.push('Logo placements: '+chosen.map(c=>c.value).join(', '));lines.push('');
   const qty=Number(row.querySelector('[data-key=quantity]').value);if(Number.isSafeInteger(qty)&&qty>0)total+=qty;
  });
  this.artwork();
  for(const field of this.querySelectorAll('[data-artwork]:not([hidden])')){
   const position=field.querySelector('legend').textContent,url=field.querySelector('[data-art-url]').value,text=field.querySelector('[data-art-text]').value.trim();
   lines.push('ARTWORK - '+position,field.querySelector('[data-art-applies]').textContent);
   if(url)lines.push('Logo file: '+url);if(text)lines.push('Logo text: '+text);lines.push('');
  }
  this.querySelector('[data-total]').textContent=total;this.addButton.hidden=this.items.children.length>=30;this.querySelector('[data-line-limit]').hidden=this.items.children.length<30;
  const summary=lines.join('\n')+'\nTotal garments: '+total;this.querySelector('[data-summary]').value=summary;this.querySelector('[data-summary-view]').textContent=summary;
 }
}
customElements.define('ck-quote-form',CKQuoteForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
